import type { ReactNode } from 'react';
import { PageHeader } from '../../../components/primitives/PageHeader';
import type { TimeRange } from '../hooks/useAnalyticsData';
import { TimeRangeSelector } from './TimeRangeSelector';

interface AnalyticsHeaderProps {
  title: string;
  subtitle?: string;
  renderTimeSelector?: () => ReactNode;
  timeRange?: TimeRange;
  onTimeRangeChange?: (range: TimeRange) => void;
}

export function AnalyticsHeader({
  title,
  subtitle,
  renderTimeSelector,
  timeRange,
  onTimeRangeChange,
}: Readonly<AnalyticsHeaderProps>) {
  const resolveRightContent = () => {
    if (renderTimeSelector) return renderTimeSelector();
    if (timeRange && onTimeRangeChange) {
      return <TimeRangeSelector value={timeRange} onChange={onTimeRangeChange} />;
    }
    return undefined;
  };
  const rightContent = resolveRightContent();

  return <PageHeader title={title} subtitle={subtitle} rightContent={rightContent} />;
}
